import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

/**
 * The VAISP (Ctrl-Alt) integration screen.
 *
 * Registered at `/settings/ctrlalt` — the path AppSidebar's Integrations group
 * and AppTopNav's title map have both pointed at since the VAISP work started,
 * with no route behind it. This is that route; the nav needed no change.
 *
 * A top-level record rather than a child of the `/settings` shell: that shell is
 * a scroll container sized for the settings forms, and this is a queue screen
 * that scrolls inside AppLayout like every other queue. Path stays under
 * `/settings/` so the sidebar's `startsWith` highlighting still lights the
 * Integrations row.
 */
export const vaspRoutes: RouteRecordRaw[] = [
  {
    path: routes.SETTINGS_VAISP_CTRL_ALT,
    name: 'SETTINGS_VAISP_CTRL_ALT',
    component: () => import('./VaspIntegrationPage.vue'),
    meta: { requiresAuth: true },
  },
]
